import React from 'react';
import './FilterStyles.css';

const PopulationFilter = ({ filter, onUpdate, onRemove, originsData }) => {
  // Calculate min/max population from origins data
  const getPopulationRange = () => {
    if (!originsData || !originsData.origins) {
      return { min: 0, max: 100000 };
    }

    const populations = originsData.origins
      .map(o => o.population || 0)
      .filter(p => p > 0);

    if (populations.length === 0) {
      return { min: 0, max: 100000 };
    }

    return {
      min: Math.floor(Math.min(...populations)),
      max: Math.ceil(Math.max(...populations))
    };
  };

  const range = getPopulationRange();
  const { minPopulation = range.min, maxPopulation = range.max } = filter.values;

  const handleMinChange = (e) => {
    const newMin = parseInt(e.target.value);
    onUpdate({
      ...filter,
      values: {
        ...filter.values,
        minPopulation: newMin,
        maxPopulation: Math.max(newMin, maxPopulation)
      }
    });
  };

  const handleMaxChange = (e) => {
    const newMax = parseInt(e.target.value);
    onUpdate({
      ...filter,
      values: {
        ...filter.values,
        minPopulation: Math.min(minPopulation, newMax),
        maxPopulation: newMax
      }
    });
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <h3>Population</h3>
        <button className="filter-remove-btn" onClick={onRemove}>×</button>
      </div>

      <div className="filter-section">
        <div className="range-display">
          <strong>Range:</strong> {minPopulation.toLocaleString()} to {maxPopulation.toLocaleString()}
        </div>

        <div className="dual-range-control">
          <div className="dual-range-wrapper">
            <input
              type="range"
              min={range.min}
              max={range.max}
              value={minPopulation}
              onChange={handleMinChange}
              className="range-slider range-slider-min"
            />
            <input
              type="range"
              min={range.min}
              max={range.max}
              value={maxPopulation}
              onChange={handleMaxChange}
              className="range-slider range-slider-max"
            />
          </div>
          <div className="dual-range-labels">
            <span className="range-label">{minPopulation.toLocaleString()}</span>
            <span className="range-label">{maxPopulation.toLocaleString()}</span>
          </div>
        </div>

        <div style={{ fontSize: '0.85rem', color: '#95a5a6', marginTop: '0.5rem', fontStyle: 'italic' }}>
          Filter postcode sectors by their total population
        </div>
      </div>
    </div>
  );
};

export default PopulationFilter;
